import { InlineMath, BlockMath } from "react-katex";
import React from "react";

export function renderStatementWithKaTeX(statement="Unfortunatly there is no problem available at the moment ...") {
  const elements = [];
  const regex = /\$\$([^$]+?)\$\$|\$([^$]+?)\$|\\\(([^)]+?)\\\)/gs;
  let lastIndex = 0;

  // Helper to turn newlines into <br />
  const renderTextWithLineBreaks = (text, keyPrefix) => {
    return text.split("\n").map((part, i) => (
      <React.Fragment key={`${keyPrefix}-${i}`}>
        {part}
        {i < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  for (const match of statement.matchAll(regex)) {
    const [fullMatch, blockMath, inlineMath1, inlineMath2] = match;
    const matchStart = match.index;

    // Add any text before the match
    if (matchStart > lastIndex) {
      elements.push(
        <span key={lastIndex}>
          {renderTextWithLineBreaks(statement.slice(lastIndex, matchStart), lastIndex)}
        </span>
      );
    }

    // Render math
    if (blockMath !== undefined) {
      elements.push(<BlockMath key={matchStart}>{blockMath.trim()}</BlockMath>);
    } else {
      const inlineContent = inlineMath1 || inlineMath2;
      elements.push(<InlineMath key={matchStart}>{inlineContent.trim()}</InlineMath>);
    }

    lastIndex = matchStart + fullMatch.length;
  }

  // Add remaining text after last match
  if (lastIndex < statement.length) {
    elements.push(
      <span key={lastIndex}>
        {renderTextWithLineBreaks(statement.slice(lastIndex), lastIndex)}
      </span>
    );
  }

  return elements;
}

export var test = {
  name: "Ahmed Mallek",
  email: "iskallop.tn@gmail.com",
  password: "yourmum123",
  role: "Student",
  studentId : "A-2013"
};

export var leaderboardData = [
  {
    name: "Yassine M.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 92,
    geometryScore: 23,
    combinatoricsScore: 22,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-09-10",
    latestHonor: "Gold Medal - April Marathon",
  },
  {
    name: "Yassine M.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 92,
    geometryScore: 23,
    combinatoricsScore: 22,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-09-10",
    latestHonor: "Gold Medal - April Marathon",
  },
  {
    name: "Yassine M.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 92,
    geometryScore: 23,
    combinatoricsScore: 22,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-09-10",
    latestHonor: "Gold Medal - April Marathon",
  },
  {
    name: "Yassine M.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 92,
    geometryScore: 23,
    combinatoricsScore: 22,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-09-10",
    latestHonor: "Gold Medal - April Marathon",
  },
  {
    name: "Rania B.",
    ViewProfileLink: "",
    region: "Tunis",
    overallScore: 87,
    geometryScore: 20,
    combinatoricsScore: 21,
    algebraScore: 23,
    arithmeticScore: 23,
    enrollmentDate: "2023-10-01",
    latestHonor: "Silver Medal - Euler Day Contest",
  },
  {
    name: "Ahmed K.",
    ViewProfileLink: "",
    region: "Sfax",
    overallScore: 95,
    geometryScore: 24,
    combinatoricsScore: 24,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-08-22",
    latestHonor: "1st Place - National Olympiad",
  },
  {
    name: "Lina Z.",
    region: "Nabeul",
    ViewProfileLink: "",
    overallScore: 88,
    geometryScore: 22,
    combinatoricsScore: 23,
    algebraScore: 22,
    arithmeticScore: 21,
    enrollmentDate: "2023-11-15",
    latestHonor: "Bronze Medal - January Challenge",
  },
  {
    name: "Omar D.",
    region: "Kairouan",
    ViewProfileLink: "",
    overallScore: 80,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2024-01-05",
    latestHonor: "Honorable Mention - Euler Day",
  },
  {
    name: "Omar D.",
    region: "Kairouan",
    ViewProfileLink: "",
    overallScore: 81,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2024-01-05",
    latestHonor: "Honorable Mention - Euler Day",
  },
  {
    name: "Omar D.",
    region: "Kairouan",
    ViewProfileLink: "",
    overallScore: 21,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2024-01-05",
    latestHonor: "Honorable Mention - Euler Day",
  },
  {
    name: "Omar D.",
    region: "Kairouan",
    ViewProfileLink: "",
    overallScore: 11,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2024-01-05",
    latestHonor: "Honorable Mention - Euler Day",
  },
  {
    name: "Omar D.",
    region: "Kairouan",
    ViewProfileLink: "",
    overallScore: 4,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2024-01-05",
    latestHonor: "Honorable Mention - Euler Day",
  },
  {
    name: "Yassine M.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 92,
    geometryScore: 23,
    combinatoricsScore: 22,
    algebraScore: 24,
    arithmeticScore: 23,
    enrollmentDate: "2023-09-10",
    latestHonor: "Gold Medal - April Marathon",
  },
  {
    name: "Alexandra K.",
    ViewProfileLink: "",
    region: "Tunis",
    overallScore: 88,
    geometryScore: 21,
    combinatoricsScore: 23,
    algebraScore: 22,
    arithmeticScore: 22,
    enrollmentDate: "2023-08-15",
    latestHonor: "Silver Medal - March Challenge",
  },
  {
    name: "Mohamed S.",
    ViewProfileLink: "",
    region: "Sfax",
    overallScore: 85,
    geometryScore: 20,
    combinatoricsScore: 22,
    algebraScore: 21,
    arithmeticScore: 22,
    enrollmentDate: "2023-07-22",
    latestHonor: "Bronze Medal - February Contest",
  },
  {
    name: "Emma L.",
    ViewProfileLink: "",
    region: "Bizerte",
    overallScore: 84,
    geometryScore: 21,
    combinatoricsScore: 20,
    algebraScore: 22,
    arithmeticScore: 21,
    enrollmentDate: "2023-10-05",
    latestHonor: "Gold Medal - Spring Tournament",
  },
  {
    name: "Omar Z.",
    ViewProfileLink: "",
    region: "Sousse",
    overallScore: 83,
    geometryScore: 20,
    combinatoricsScore: 21,
    algebraScore: 21,
    arithmeticScore: 21,
    enrollmentDate: "2023-09-18",
    latestHonor: "Silver Medal - Winter Cup",
  },
  {
    name: "Sophia C.",
    ViewProfileLink: "",
    region: "Nabeul",
    overallScore: 81,
    geometryScore: 19,
    combinatoricsScore: 21,
    algebraScore: 20,
    arithmeticScore: 21,
    enrollmentDate: "2023-11-12",
    latestHonor: "Bronze Medal - Autumn League",
  },
  {
    name: "Karim B.",
    ViewProfileLink: "",
    region: "Kairouan",
    overallScore: 80,
    geometryScore: 19,
    combinatoricsScore: 20,
    algebraScore: 21,
    arithmeticScore: 20,
    enrollmentDate: "2023-08-30",
    latestHonor: "Honorable Mention - Summer Series",
  },
  {
    name: "Lina T.",
    ViewProfileLink: "",
    region: "Monastir",
    overallScore: 78,
    geometryScore: 18,
    combinatoricsScore: 20,
    algebraScore: 19,
    arithmeticScore: 21,
    enrollmentDate: "2023-10-22",
    latestHonor: "Gold Medal - Coastal Championship",
  },
  {
    name: "Adam R.",
    ViewProfileLink: "",
    region: "Mahdia",
    overallScore: 77,
    geometryScore: 18,
    combinatoricsScore: 19,
    algebraScore: 20,
    arithmeticScore: 20,
    enrollmentDate: "2023-09-05",
    latestHonor: "Silver Medal - Desert Challenge",
  },
  {
    name: "Leila M.",
    ViewProfileLink: "",
    region: "Tozeur",
    overallScore: 76,
    geometryScore: 18,
    combinatoricsScore: 19,
    algebraScore: 19,
    arithmeticScore: 20,
    enrollmentDate: "2023-11-08",
    latestHonor: "Bronze Medal - Oasis Olympiad",
  },
  {
    name: "Daniel P.",
    ViewProfileLink: "",
    region: "Tataouine",
    overallScore: 75,
    geometryScore: 17,
    combinatoricsScore: 19,
    algebraScore: 19,
    arithmeticScore: 20,
    enrollmentDate: "2023-10-15",
    latestHonor: "Star Performer - October",
  },
  {
    name: "Amina K.",
    ViewProfileLink: "",
    region: "Gafsa",
    overallScore: 74,
    geometryScore: 17,
    combinatoricsScore: 18,
    algebraScore: 19,
    arithmeticScore: 20,
    enrollmentDate: "2023-09-28",
    latestHonor: "Rising Star - September",
  },
  {
    name: "Ryan H.",
    ViewProfileLink: "",
    region: "Beja",
    overallScore: 73,
    geometryScore: 17,
    combinatoricsScore: 18,
    algebraScore: 18,
    arithmeticScore: 20,
    enrollmentDate: "2023-08-10",
    latestHonor: "Consistent Performer Award",
  },
  {
    name: "Nadia F.",
    ViewProfileLink: "",
    region: "Jendouba",
    overallScore: 72,
    geometryScore: 16,
    combinatoricsScore: 18,
    algebraScore: 18,
    arithmeticScore: 20,
    enrollmentDate: "2023-07-30",
    latestHonor: "Most Improved - Q3",
  },
  {
    name: "Ethan W.",
    ViewProfileLink: "",
    region: "Kef",
    overallScore: 71,
    geometryScore: 16,
    combinatoricsScore: 17,
    algebraScore: 18,
    arithmeticScore: 20,
    enrollmentDate: "2023-10-01",
    latestHonor: "Problem Solver Award",
  },
  {
    name: "Hana S.",
    ViewProfileLink: "",
    region: "Siliana",
    overallScore: 70,
    geometryScore: 16,
    combinatoricsScore: 17,
    algebraScore: 17,
    arithmeticScore: 20,
    enrollmentDate: "2023-09-15",
    latestHonor: "Creative Thinker Award",
  },
  {
    name: "Lucas G.",
    ViewProfileLink: "",
    region: "Zaghouan",
    overallScore: 69,
    geometryScore: 15,
    combinatoricsScore: 17,
    algebraScore: 17,
    arithmeticScore: 20,
    enrollmentDate: "2023-08-25",
    latestHonor: "Speed Math Champion",
  },
  {
    name: "Yara D.",
    ViewProfileLink: "",
    region: "Ben Arous",
    overallScore: 68,
    geometryScore: 15,
    combinatoricsScore: 16,
    algebraScore: 17,
    arithmeticScore: 20,
    enrollmentDate: "2023-11-05",
    latestHonor: "Geometry Specialist",
  },
  {
    name: "Noah B.",
    ViewProfileLink: "",
    region: "Ariana",
    overallScore: 67,
    geometryScore: 15,
    combinatoricsScore: 16,
    algebraScore: 16,
    arithmeticScore: 20,
    enrollmentDate: "2023-10-18",
    latestHonor: "Number Theory Expert",
  },
  {
    name: "Salma W.",
    ViewProfileLink: "",
    region: "Manouba",
    overallScore: 66,
    geometryScore: 14,
    combinatoricsScore: 16,
    algebraScore: 16,
    arithmeticScore: 20,
    enrollmentDate: "2023-09-22",
    latestHonor: "Algebra Ace",
  },
  {
    name: "Khalil N.",
    ViewProfileLink: "",
    region: "Medenine",
    overallScore: 65,
    geometryScore: 14,
    combinatoricsScore: 15,
    algebraScore: 16,
    arithmeticScore: 20,
    enrollmentDate: "2023-08-08",
    latestHonor: "Combinatorics Wizard",
  },
  {
    name: "Elena R.",
    ViewProfileLink: "",
    region: "Kebili",
    overallScore: 64,
    geometryScore: 14,
    combinatoricsScore: 15,
    algebraScore: 15,
    arithmeticScore: 20,
    enrollmentDate: "2023-07-15",
    latestHonor: "Most Consistent Solver",
  },
  {
    name: "Ziad A.",
    ViewProfileLink: "",
    region: "Tunis",
    overallScore: 63,
    geometryScore: 13,
    combinatoricsScore: 15,
    algebraScore: 15,
    arithmeticScore: 20,
    enrollmentDate: "2023-10-30",
    latestHonor: "Quick Thinker Award",
  },
  {
    name: "Maya H.",
    ViewProfileLink: "",
    region: "Sfax",
    overallScore: 62,
    geometryScore: 13,
    combinatoricsScore: 14,
    algebraScore: 15,
    arithmeticScore: 20,
    enrollmentDate: "2023-09-03",
    latestHonor: "Perseverance Award",
  },
  {
    name: "Samir K.",
    ViewProfileLink: "",
    region: "Gabes",
    overallScore: 61,
    geometryScore: 13,
    combinatoricsScore: 14,
    algebraScore: 14,
    arithmeticScore: 20,
    enrollmentDate: "2023-08-17",
    latestHonor: "Most Improved - August",
  },
];

export var UsefullLinksSet = [
  {
    name: "IMO",
    fullName: "International Math Olympiad",
    type: "Contest",
    level: "Advanced",
    region: "Global",
    focus: "Proof-based Solutions",
    url: "https://www.imo-official.org",
  },
  {
    name: "PAMO",
    fullName: "Pan African Math Olympiad",
    type: "Contest",
    level: "Advanced",
    region: "Africa",
    focus: "Proof-based Solutions",
    url: "https://artofproblemsolving.com/wiki/index.php/Pan_African_Mathematics_Olympiad?srsltid=AfmBOoqx3onK94uuDqQUsM_91DasrEmERPqbm3xIaEUA5bNvWAMD27Cl",
  },
  {
    name: "EGMO",
    fullName: "European Girls Math Olympiad",
    type: "Contest",
    level: "Advanced",
    region: "Europe (International participants)",
    focus: "Proof-based Solutions",
    url: "https://www.egmo.org",
  },
  {
    name: "OFM",
    fullName: "Francophone Math Olympiad",
    type: "Contest",
    level: "Advanced",
    region: "Francophone Regions",
    focus: "Proof-based Solutions",
    url: "https://ofm2025.maths-olympiques.fr/a-propos/",
  },
  {
    name: "AoPS",
    fullName: "Art of Problem Solving",
    type: "Training",
    level: "Beginner to Olympiad",
    region: "USA (Global Access)",
    focus: "All math contest topics, Community Forum",
    url: "https://artofproblemsolving.com",
  },
  {
    name: "Mathraining",
    fullName: "Mathraining",
    type: "Training",
    level: "Intermediate to Advanced",
    region: "Francophone (International)",
    focus: "Olympiad prep",
    url: "https://www.mathraining.be",
  },

  // Add more entries as needed
];

export var problemArchive = [
  {
    Type: "Marathon",
    Subject: "April Marathon",
    Author: "Ahmed Mallek",
    Date: "14/05/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
  {
    Type: "Marathon",
    Subject: "April Marathon",
    Author: "Ahmed Mallek",
    Date: "14/05/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
  {
    Type: "Marathon",
    Subject: "April Marathon",
    Author: "Ahmed Mallek",
    Date: "14/05/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
  {
    Type: "Marathon",
    Subject: "April Marathon",
    Author: "Ahmed Mallek",
    Date: "14/05/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
  {
    Type: "Marathon",
    Subject: "April Marathon",
    Author: "Ahmed Mallek",
    Date: "14/05/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },

  {
    Type: "Practice Test",
    Subject: "Number Theory Practice",
    Author: "Ahmed Mallek",
    Date: "10/04/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
  {
    Type: "Mock Contest",
    Subject: "Spring Mock",
    Author: "Ahmed Mallek",
    Date: "02/03/2025",
    Results: "Results.pdf",
    Paper: "Download",
  },
];

export var OpenProblemSet = [
  {
    BgColor: "#a5f5a5",
    Status: "Open",
    Image: "",
    Title: "A Tiling Conjecture",
    Field: "Combinatorics",
    url: "#",
    Difficulty: 3,
    OverleafCode: "",
    Solution: "",
  },

  {
    BgColor: "#ffee77",
    Status: "Open",
    Image: "",
    Title: "Primes in Arithmetic Progressions",
    Field: "Number Theory",
    url: "#",
    Difficulty: 3,
    OverleafCode: "",
    Solution: "",
  },

  {
    BgColor: "#ffaaaa",
    Status: "Submitted",
    Image: "",
    Title: "A Curious Diophantine Equation",
    Field: "Number Theory",
    url: "#",
    Difficulty: 1,
    OverleafCode: "",
    Solution: "",
  },

  {
    BgColor: "#a5d5f5",
    Status: "Open",
    Image: "",
    Title: "Geometric Inequality Challenge",
    Field: "Geometry",
    url: "#",
    Difficulty: 2,
    OverleafCode: "",
    Solution: "",
  },

  {
    BgColor: "#eeeeee",
    Status: "Submitted",
    Image: "",
    Title: "A Recursive Combinatorial Problem",
    Field: "Combinatorics",
    url: "#",
    Difficulty: 3,
    OverleafCode: "",
    Solution: "",
  },

  {
    BgColor: "#ffaaaa",
    Status: "Corrected",
    Image: "",
    Title: "The Power of Two Conjecture",
    Field: "Algebra",
    url: "#",
    Difficulty: 3,
    OverleafCode: "",
    Solution: "",
  },
  {
    BgColor: "#a5f5a5",
    Status: "Open",
    Image: "",
    Title: "A Functional Equation Riddle",
    Field: "Algebra",
    url: "#",
    Difficulty: 2,
    OverleafCode: "",
    Solution: "",
  },
  {
    BgColor: "#da6923",
    Status: "Submitted",
    Image: "",
    Title: "The Golden Ratio in Triangles",
    Field: "Geometry",
    url: "#",
    Difficulty: 2,
    OverleafCode: "",
    Solution: "",
  },
  {
    BgColor: "#eeeeee",
    Status: "Corrected",
    Image: "",
    Title: "Partition Function Mystery",
    Field: "Number Theory",
    url: "#",
    Difficulty: 2,
    OverleafCode: "",
    Solution: "",
  },
  {
    BgColor: "#ffaaaa",
    Status: "Open",
    Image: "",
    Title: "Combinatorial Games Strategy",
    Field: "Combinatorics",
    url: "#",
    Difficulty: 1,
    OverleafCode: "",
    Solution: "",
  },
];

export var studentSubmissions = [
  {
    Number: "#1",
    studentName: "Alice Johnson",
    profileLink: "/students/alice-johnson",
    submissionType: "Daily Problem",
    submissionDate: "15/11/2023", // Changed from "2023-11-15"
    downloadLink: "/submissions/alice-daily-1115.pdf",
  },
  {
    Number: "#2",
    studentName: "Bob Smith",
    profileLink: "/students/bob-smith",
    submissionType: "Weekly Problem",
    submissionDate: "12/11/2023", // Changed from "2023-11-12"
    downloadLink: "/submissions/bob-weekly-1112.docx",
  },
  {
    Number: "#3",
    studentName: "Charlie Brown",
    profileLink: "/students/charlie-brown",
    submissionType: "Open Problem",
    submissionDate: "10/11/2023", // Changed from "2023-11-10"
    downloadLink: "/submissions/charlie-open-1110.zip",
  },
  {
    Number: "#4",
    studentName: "Diana Miller",
    profileLink: "/students/diana-miller",
    submissionType: "Daily Problem",
    submissionDate: "14/11/2023", // Changed from "2023-11-14"
    downloadLink: "/submissions/diana-daily-1114.pdf",
  },
  {
    Number: "#5",
    studentName: "Ethan Wilson",
    profileLink: "/students/ethan-wilson",
    submissionType: "Weekly Problem",
    submissionDate: "05/11/2023", // Changed from "2023-11-05"
    downloadLink: "/submissions/ethan-weekly-1105.pdf",
  },
  {
    Number: "#7",
    studentName: "George Davis",
    profileLink: "/students/george-davis",
    submissionType: "Daily Problem",
    submissionDate: "13/11/2023", // Changed from "2023-11-13"
    downloadLink: "/submissions/george-daily-1113.pdf",
  },
  {
    Number: "#6",
    studentName: "Fiona Chen",
    profileLink: "/students/fiona-chen",
    submissionType: "Open Problem",
    submissionDate: "08/11/2023", // Changed from "2023-11-08"
    downloadLink: "/submissions/fiona-open-1108.docx",
  },
];

export var gradedSubmissions = [
  {
    student: {
      name: "Alice Johnson",
      profileLink: "/students/alice-johnson",
    },
    submissionType: "Daily Problem",
    corrector: {
      name: "Dr. Smith",
      profileLink: "/staff/smith",
    },
    correctionDate: "16/11/2023", // Updated from "2023-11-16"
    submission: {
      downloadLink: "/submissions/alice-daily-1115.pdf",
      originalDate: "15/11/2023", // Updated from "2023-11-15"
    },
    score: 85,
    feedback:
      "Good work overall, but needs more detailed explanations in section 3.",
  },
  {
    student: {
      name: "Bob Chen",
      profileLink: "/students/bob-chen",
    },
    submissionType: "Weekly Problem",
    corrector: {
      name: "Prof. Lee",
      profileLink: "/staff/lee",
    },
    correctionDate: "13/11/2023", // Updated from "2023-11-13"
    submission: {
      downloadLink: "/submissions/bob-weekly-1112.docx",
      originalDate: "12/11/2023", // Updated from "2023-11-12"
    },
    score: 92,
    feedback: "Excellent solution! Clear methodology and well-formatted.",
  },
  {
    student: {
      name: "Charlie Brown",
      profileLink: "/students/charlie-brown",
    },
    submissionType: "Open Problem",
    corrector: {
      name: "Dr. Smith",
      profileLink: "/staff/smith",
    },
    correctionDate: "11/11/2023", // Updated from "2023-11-11"
    submission: {
      downloadLink: "/submissions/charlie-open-1110.zip",
      originalDate: "10/11/2023", // Updated from "2023-11-10"
    },
    score: 78,
    feedback: "Creative approach, but missing citations for referenced works.",
  },
  {
    student: {
      name: "Diana Miller",
      profileLink: "/students/diana-miller",
    },
    submissionType: "Daily Problem",
    corrector: {
      name: "Prof. Garcia",
      profileLink: "/staff/garcia",
    },
    correctionDate: "15/11/2023", // Updated from "2023-11-15"
    submission: {
      downloadLink: "/submissions/diana-daily-1114.pdf",
      originalDate: "14/11/2023", // Updated from "2023-11-14"
    },
    score: 88,
    feedback: "Very thorough analysis. Minor calculation errors in results.",
  },
  {
    student: {
      name: "Ethan Wilson",
      profileLink: "/students/ethan-wilson",
    },
    submissionType: "Weekly Problem",
    corrector: {
      name: "Prof. Lee",
      profileLink: "/staff/lee",
    },
    correctionDate: "06/11/2023", // Updated from "2023-11-06"
    submission: {
      downloadLink: "/submissions/ethan-weekly-1105.pdf",
      originalDate: "05/11/2023", // Updated from "2023-11-05"
    },
    score: 95,
    feedback: "Outstanding work! Exemplary problem-solving technique.",
  },
];

export var WeeklyProblems = [
  {
    Week: 1,
    Problems: [
      {
        type: "📘 Problem of the Week: N°1",
        Statement:
          "Find one pair of positive integers $(a,b)$ such that $ab(a+b)$ is not divisible by $7$, but $(a+b)^7 - a^7 - b^7$ is divisible by $7^7.$",
        difficulty: "Easy",
        tags: ["Number Theory", "Proof based"],
        date: "Week 1 - Problem 1",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°2",
        Statement:
          "Determine all positive, composite integer $n$ that satisfy the following property: if the positive divisors of $n$ are $1=d_1 < d_2 < \\ldots < d_k=n$, then $d_i$ divides $d_{i+1}+d_{i+2}$ for all $1 \\leq i \\leq k-2.$",
        difficulty: "Easy",
        tags: ["Combinatorics", "Divisors"],
        date: "Week 1 - Problem 2",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°3",
        Statement:
          "Let $ABC$ be a triangle with incenter $I$. Let $D$ be a point on side $BC$ and let $\\omega_B$ and $\\omega_C$ be the incircles of $\\triangle ABD$ and $\\triangle ACD$, respectively. Suppose that $\\omega_B$ and $\\omega_C$ are tangent to segment $BC$ at points $E$ and $F$, respectively. Let $P$ be the intersection of segment $AD$ with the line joining the centers of $\\omega_B$ and $\\omega_C$. Let $X$ be the intersection point of lines $BI$ and $CP$ and let $Y$ be the intersection point of lines $CI$ and $BP$. Prove that lines $EX$ and $FY$ meet on the incircle of $\\triangle ABC$.",
        difficulty: "Easy",
        tags: ["Geometry", "Incircles"],
        date: "Week 1 - Problem 3",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°4",
        Statement: "",
        difficulty: "Easy",
        tags: ["Algebra"],
        date: "Week 1 - Problem 4",
        author: "MathTounsi Team",
        link: "#",
      },
    ],
  },
  {
    Week: 2,
    Problems: [
      {
        type: "📘 Problem of the Week: N°5",
        Statement:
          "Let $x, y$ be real numbers such that $x + y = 4$ and $x^2 + y^2 = 10$. Find the maximum value of $xy$.",
        difficulty: "Easy",
        tags: ["Algebra", "Quadratics"],
        date: "Week 2 - Problem 1",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°6",
        Statement:
          "Find all positive integers $n$ such that $n^2 + n + 1$ is divisible by $7$.",
        difficulty: "Easy",
        tags: ["Number Theory"],
        date: "Week 2 - Problem 2",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°7",
        Statement:
          "In how many ways can you place $5$ indistinguishable balls into $3$ distinguishable boxes such that no box is empty?",
        difficulty: "Easy",
        tags: ["Combinatorics"],
        date: "Week 2 - Problem 3",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°8",
        Statement:
          "In triangle $ABC$, $AB = AC$ and the angle bisector of $\\angle BAC$ meets $BC$ at $D$. Prove that $AD$ is perpendicular to the angle bisector of $\\angle ABC$.",
        difficulty: "Easy",
        tags: ["Geometry", "Angle Bisectors"],
        date: "Week 2 - Problem 4",
        author: "MathTounsi Team",
        link: "#",
      },
    ],
  },
  {
    Week: 3,
    Problems: [
      {
        type: "📘 Problem of the Week: N°9",
        Statement:
          "Let $x, y$ be real numbers such that $x + y = 4$ and $x^2 + y^2 = 10$. Find the maximum value of $xy$.",
        difficulty: "Easy",
        tags: ["Algebra", "Quadratics"],
        date: "Week 3 - Problem 1",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°10",
        Statement:
          "Find all positive integers $n$ such that $n^2 + n + 1$ is divisible by $7$.",
        difficulty: "Easy",
        tags: ["Number Theory"],
        date: "Week 3 - Problem 2",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°11",
        Statement:
          "In how many ways can you place $5$ indistinguishable balls into $3$ distinguishable boxes such that no box is empty?",
        difficulty: "Easy",
        tags: ["Combinatorics"],
        date: "Week 3 - Problem 3",
        author: "MathTounsi Team",
        link: "#",
      },
      {
        type: "📘 Problem of the Week: N°12",
        Statement:
          "In triangle $ABC$, $AB = AC$ and the angle bisector of $\\angle BAC$ meets $BC$ at $D$. Prove that $AD$ is perpendicular to the angle bisector of $\\angle ABC$.",
        difficulty: "Easy",
        tags: ["Geometry", "Angle Bisectors"],
        date: "Week 3 - Problem 4",
        author: "MathTounsi Team",
        link: "#",
      },
    ],
  },
];

export var archiveData = [
  {
    Name: "Ahmed.M",
    Profile: "#",
    Score: "777777777777",
    Reward: "Gold",
    CorrectionStatus: "101",
  },
  {
    Name: "Sara.B",
    Profile: "#",
    Score: "675432198000",
    Reward: "Silver",
    CorrectionStatus: "111",
  },
  {
    Name: "Youssef.K",
    Profile: "#",
    Score: "589103245000",
    Reward: "Bronze",
    CorrectionStatus: "001",
  },
  {
    Name: "Lina.S",
    Profile: "#",
    Score: "470000000123",
    Reward: "Medal",
    CorrectionStatus: "100",
  },
  {
    Name: "Omar.N",
    Profile: "#",
    Score: "468999999999",
    Reward: "Medal",
    CorrectionStatus: "101",
  },
  {
    Name: "Rania.Z",
    Profile: "#",
    Score: "455500000000",
    Reward: "Medal",
    CorrectionStatus: "101",
  },
  {
    Name: "Karim.A",
    Profile: "#",
    Score: "444444444444",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
  {
    Name: "Hana.E",
    Profile: "#",
    Score: "430000000000",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
  {
    Name: "Firas.L",
    Profile: "#",
    Score: "419999999999",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
  {
    Name: "Nada.T",
    Profile: "#",
    Score: "400000000000",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
  {
    Name: "Nada.T",
    Profile: "#",
    Score: "400000000000",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
  {
    Name: "Nada.T",
    Profile: "#",
    Score: "400000000000",
    Reward: "Participant",
    CorrectionStatus: "101",
  },
];

export var AnnoucementPosts = [
  {
    Date: "August 3 2025",
    Title: "Welcome to the New Era",
    Type: "News",
    Content:
      "Beneath the fading orange glow of the late summer sky, a small group of children chased fireflies across an open field, their laughter echoing through the warm evening air. The tall grass swayed gently with the breeze, brushing against their legs like whispers from the earth.",
    Poster: "Ahmed Mallek",
  },
  {
    Date: "July 29 2025",
    Title: "A Storm on the Horizon",
    Type: "News",
    Content:
      "Dark clouds gathered swiftly above the coastline, rumbling low as if warning the village of what was to come. Seagulls scattered inland, and fishermen hauled in their nets with urgency as the scent of rain thickened the air.",
    Poster: "Ahmed Mallek",
  },
  {
    Date: "July 15 2025",
    Title: "Midnight in the Library",
    Type: "Article",
    Content:
      "The old library came alive at midnight. Not with noise or movement, but with the silent energy of forgotten stories waiting to be read again. The scent of aged paper mixed with candle wax created a timeless atmosphere where ideas wandered freely.",
    Poster: "Ahmed Mallek",
  },
  {
    Date: "June 30 2025",
    Title: "Whispers of the Old Forest",
    Type: "Story",
    Content:
      "They say the trees in the old forest remember everything—the laughter of children, the cries of lost travelers, the songs of the wind. And if you listen closely at dusk, the leaves will tell you tales long buried under moss and bark.",
    Poster: "Ahmed Mallek",
  },
  {
    Date: "June 20 2025",
    Title: "The Clocktower Reawakens",
    Type: "News",
    Content:
      "After decades of silence, the town’s clocktower struck twelve once more, its chimes rolling through the valley like a call to memory. People gathered in the square, drawn by a sound many had only heard in their grandparents’ stories.",
    Poster: "Ahmed Mallek",
  },
  {
    Date: "May 5 2025",
    Title: "The Day the Sky Turned Violet",
    Type: "Article",
    Content:
      "No one expected the sky to shift so dramatically. Just before sunset, the usual amber hue gave way to a rich, violet glow that shimmered like silk. Cameras flashed and eyes widened, unsure whether it was science or magic at work.",
    Poster: "Ahmed Mallek",
  },
];


const Submissions = [
  {
    problemRefCode: 'NT-W-001',
    studentId: 'student123',
    submissionDate: new Date('2025-08-01T10:00:00Z'),
    answer: '/uploads/submissions/NT-W-001_student123.pdf',
    correctorId: 'corrector001',
    correctionDate: new Date('2025-08-02T12:00:00Z'),
    messages: [
      {
        senderId: 'student123',
        message: 'I’m not sure if my method is valid, please check the second part.',
        timestamp: new Date('2025-08-01T10:15:00Z')
      },
      {
        senderId: 'corrector001',
        message: 'I’ll review it. Thanks for the heads up!',
        timestamp: new Date('2025-08-01T11:00:00Z')
      }
    ],
    finalScore: 6,
    status: 'Corrected'
  },
  {
    problemRefCode: 'ALG-D-002',
    studentId: 'student456',
    submissionDate: new Date('2025-08-05T09:30:00Z'),
    answer: '/uploads/submissions/ALG-D-002_student456.pdf',
    correctorId: 'corrector003',
    correctionDate: new Date('2025-08-06T14:45:00Z'),
    messages: [
      {
        senderId: 'student456',
        message: 'Can you provide feedback even if it’s all correct?',
        timestamp: new Date('2025-08-05T09:35:00Z')
      }
    ],
    finalScore: 7,
    status: 'Corrected'
  },
  {
    problemRefCode: 'GEO-U-005',
    studentId: 'student789',
    submissionDate: new Date('2025-08-07T08:00:00Z'),
    answer: '/uploads/submissions/GEO-U-005_student789.pdf',
    messages: [],
    status: 'Submitted'
  },
  {
    problemRefCode: 'COM-W-010',
    studentId: 'student321',
    submissionDate: new Date('2025-08-06T13:00:00Z'),
    answer: '/uploads/submissions/COM-W-010_student321.pdf',
    correctorId: 'corrector005',
    correctionDate: new Date('2025-08-07T10:00:00Z'),
    messages: [
      {
        senderId: 'student321',
        message: 'I had a mistake in line 2 but fixed it later.',
        timestamp: new Date('2025-08-06T13:30:00Z')
      },
      {
        senderId: 'corrector005',
        message: 'Thanks for clarifying. I’ll consider that.',
        timestamp: new Date('2025-08-07T09:00:00Z')
      }
    ],
    finalScore: 5,
    status: 'Corrected'
  }
];
